export class SalesMessagesSectionConfig {

    private readonly section = 'SALES_MESSAGES_SECTION';
    private imagesPath = 'assets/images';

    constructor() {}

    createConfig(): SalesMessageConfig[] {
        return [
            {
                title: `${this.section}.DISCOUNT_MESSAGE.title`,
                listItems: [
                    `${this.section}.DISCOUNT_MESSAGE.listItem1`,
                    `${this.section}.DISCOUNT_MESSAGE.listItem2`,
                ],
                images: [
                    { src: `${this.imagesPath}/laur-eksperta.webp`, attrWidth: 54, attrHeight: 50 },
                ]
            },
            {
                title: `${this.section}.ONLINE_MESSAGE.title`,
                listItems: [
                    `${this.section}.ONLINE_MESSAGE.listItem1`,
                    `${this.section}.ONLINE_MESSAGE.listItem2`,
                ],
                images: [
                    { src: `${this.imagesPath}/przelewy-24.svg`, attrWidth: 55, attrHeight: 19 },
                    { src: `${this.imagesPath}/blik.svg`, maxHeight: 26, attrWidth: 49, attrHeight: 26 },
                    { src: `${this.imagesPath}/visa.svg`, attrWidth: 55, attrHeight: 18 },
                    { src: `${this.imagesPath}/mastercard.svg`, maxHeight: 36, attrWidth: 46, attrHeight: 36 },
                ]
            },
            {
                title: `${this.section}.SUPPORT_MESSAGE.title`,
                listItems: [
                    `${this.section}.SUPPORT_MESSAGE.listItem1`,
                    `${this.section}.SUPPORT_MESSAGE.listItem2`,
                ],
                images: [
                    { src: `${this.imagesPath}/knf.svg`, minWidth: 120, attrWidth: 120, attrHeight: 26 }
                ]
            },
            {
                title: `${this.section}.SECURITY_MESSAGE.title`,
                listItems: [
                    `${this.section}.SECURITY_MESSAGE.listItem1`,
                ],
                images: [
                    { src: `${this.imagesPath}/cloudflare.webp`, maxWidth: 75, attrHeight: 25, attrWidth: 75 },
                    { src: `${this.imagesPath}/ssl.webp`, minWidth: 64, marginLeft: 10, attrWidth: 64, attrHeight: 34 },
                ]
            },
        ];
    }
}

export interface SalesMessageConfig {
    title: string;
    listItems?: string[];
    images?: {
        src: string;
        attrWidth: number;
        attrHeight: number;
        minWidth?: number;
        maxHeight?: number;
        maxWidth?: number;
        marginLeft?: number;
    }[];
}
